import { RouteRecordRaw } from 'vue-router';
import AuraChat from '@/views/pages/aura/AuraChat.vue';
import AuraProcessingCosts from '@/views/pages/aura/AuraProcessingCosts.vue';

const auraRoutes: RouteRecordRaw = {
    name: 'Aura',
    path: '/aura',
    meta: { isLevelLocked: true },
    children: [
        {
            name: 'AuraChat',
            path: '',
            component: AuraChat,
        },
        {
            name: 'AuraProcessingCosts',
            path: 'custos',
            component: AuraProcessingCosts,
        },
    ],
};

export default auraRoutes;
